import { useContext } from "react";
import { AuthContext } from "types/auth";
import Context from "./Context";
export { default as withAuth } from "./with.js";
export { default } from "./Provider.js";

export function useAuth(): AuthContext | null {
  return useContext(Context);
}
